import React, { Suspense } from "react";
import { useLanguage } from "../ui/LanguageProvider";
import LoadingBar, { useDelayedFlag } from "../ui/LoadingBar";
import { Skeleton, SkeletonRows } from "../ui/Skeleton";

// 라우트 코드 스플리팅용 공용 Suspense 경계. 셸(사이드바/탑바)은 유지하고
// 콘텐츠 영역에서만 fallback 을 보여준다(전체 화면 플래시 방지).
// DESIGN-AI §30 패턴 H — 300ms 안에 오면 아무것도 안 보이고, 넘으면 맨 위 2px 막대 + 화면 모양 스켈레톤
// (머리 · 툴바 · 표). 예전 가운데 스피너 「로딩 중…」은 짧게 지나가도 매번 본문이 비어 깜빡였다.
function Fallback() {
  const { t } = useLanguage();
  const shown = useDelayedFlag(true, 300);
  return (
    <div data-crm-i18n-skip="true" className="ds-scope relative min-h-[280px] px-6 pt-5" aria-busy="true">
      <LoadingBar active delay={300} label={t("화면 불러오는 중", "Loading page")} />
      {shown ? (
        <div style={{ display: "grid", gap: 16 }}>
          <Skeleton width={220} height={24} />
          <div style={{ display: "flex", gap: 8 }}>
            <Skeleton width={96} height={32} className="rounded-[7px]" />
            <Skeleton width={140} height={32} className="rounded-[7px]" />
            <Skeleton width={180} height={32} className="rounded-[7px]" />
          </div>
          <SkeletonRows rows={6} cols={4} label={t("화면 불러오는 중", "Loading page")} />
        </div>
      ) : null}
    </div>
  );
}

export default function RouteSuspense({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<Fallback />}>{children}</Suspense>;
}
